import { ApiProperty } from '@nestjs/swagger';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsUUID } from 'class-validator';
import { Expose } from 'class-transformer';
import { UserDto } from '../../user/dto/user.dto';
import { SupplierRepresentativeInterface } from '../interfaces/supplier-representative.interface';
import { SupplierDto } from '../../supplier/dto/supplier.dto';
import { UserInterface } from '../../user/interfaces/user.interface';

export class SupplierRepresentativeDto
  extends CommonEntityDto
  implements SupplierRepresentativeInterface
{
  supplier?: SupplierDto | undefined;

  @ApiProperty({
    format: 'uuid',
    title: 'Supplier ID',
    description: 'Supplier ID',
  })
  @IsUUID()
  @Expose()
  supplierId!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'User ID',
    description: 'User id',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiProperty({
    type: () => UserDto,
    title: 'Representative User',
    description: 'Representative User',
  })
  @Expose()
  user?: UserInterface | undefined;
}
